module.exports = __webpack_public_path__ + "static/media/installation-video-ios-EN.0065c8be.mp4";